import { render, staticRenderFns } from "./fenxiao_del.vue?vue&type=template&id=197ae8da&scoped=true"
import script from "./fenxiao_del.vue?vue&type=script&lang=js"
export * from "./fenxiao_del.vue?vue&type=script&lang=js"
import style0 from "./fenxiao_del.vue?vue&type=style&index=0&id=197ae8da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197ae8da",
  null
  
)

export default component.exports